import { replaceDateObjectWithTimeStamp } from '@modules/common/utils';
import { SearchQuery } from '@modules/feed/types';
import { serializeSearchParams } from '@modules/feed/utils/serializeSearchParams';

export const getSearchParams = ({ duration, whereClause }: SearchQuery) => {
  const parsedDuration = serializeSearchParams(
    replaceDateObjectWithTimeStamp(duration),
  );
  const parsedWhereClause = serializeSearchParams(whereClause);

  return `?duration=${parsedDuration}&where=${parsedWhereClause}`;
};
